export function navigateToRingApp(url) {
  if (window.ringapp) {
    window.ringapp.sendMessage(
      JSON.stringify({
        id: 1,
        operation: 'navigate',
        body: { url, target: 'app' },
      }),
    );
  }
}
